const getters = {
  language: state => state.app.language,
  unReadNum: state => state.app.unReadNum,
  authorities: state => state.user.authorities,
  userInfo: state => state.user.userInfo,
  payInfo: state => state.user.payInfo,
  detailUserInfo: state => state.user.detailUserInfo,
  userAmountInfo: state => state.user.userAmountInfo,
  ekycUserInfo: state => state.user.ekycUserInfo,
  isBluepay: state => state.app.isBluepay
}
export default getters
